/** Digit count for BPJS Kesehatan numbers */
export const KESEHATAN_LENGTH = 13;

/** Digit count for BPJS Ketenagakerjaan numbers */
export const KETENAGAKERJAAN_LENGTH = 11;
